import gql from 'graphql-tag'

export const GET_WHY_WE_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getWhyWePaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleKg
        titleRu
        homeId
        isService
      }
    }
  }
`

export const GET_WHY_WE_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getWhyWe (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleKg
      titleRu
      descriptionEn
      descriptionKg
      descriptionRu
      quoteEn
      quoteKg
      quoteRu
      tagsEn
      tagsKg
      tagsRu
      homeId
      isService
    }
  }
`

export const GET_WHY_WE_IMAGES_QUERY = gql`
  query {
    getWhyWeImages {
      coverImage
      url
    }
  }
`
